
export enum Month {
  january = 0,
  february = 1,
  march = 2,
  april = 3,
  may = 4,
  june = 5,
  july = 6,
  august = 7,
  september = 8,
  october = 9,
  november = 10,
  december = 11,
}

export const MonthToString:  {[key in Month]: string}  = {
  [Month.january]: 'January',
  [Month.february]: 'February',
  [Month.march]: 'March',
  [Month.april]: 'April',
  [Month.may]: 'May',
  [Month.june]: 'June',
  [Month.july]: 'July',
  [Month.august]: 'August',
  [Month.september]: 'September',
  [Month.october]: 'October',
  [Month.november]: 'November',
  [Month.december]: 'December',

};
